<template>
  <div class="bgBox">
    <div class="headerBox">
      <HearderPage title="长护险服务运营平台" />
    </div>
    <div class="main-area">
      <router-view />
    </div>
  </div>
</template>

<script>
import HearderPage from "@/components/hearderPage.vue";

export default {
  name: "Layout",
  components: { HearderPage },
};
</script>

<style lang="less">
.bgBox {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background: rgba(5, 16, 46, 1) url("@/assets/BGa.png") no-repeat center
    center/ 100% 100%;
}

.headerBox {
  flex: 0 0 auto;
  position: relative;
  width: 100%;
  height: 81px;
  z-index: 5;
}

.main-area {
  flex: 1;
  overflow: hidden;
}
</style>
